import { Modal } from 'react-bootstrap';

import { JSONEditorTask } from '../../components/JSONEditorTask/JSONEditorTask';
import { EditorStatusSelect } from '../../components/EditorStatusSelect/EditorStatusSelect';
import { EditorTaskTypeSelect } from '../../components/EditorTaskTypeSelect/EditorTaskTypeSelect';
import { EditorTaskSubmitButton } from '../../components/EditorTaskSubmitButton/EditorTaskSubmitButton';

export const SupportTaskOrchestrator = () => (
  <>
    <Modal.Body>
      <div className="d-flex gap-2 align-items-start">
        <JSONEditorTask />
        <div className="d-flex flex-column gap-2">
          <EditorStatusSelect />
          <EditorTaskTypeSelect />
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <EditorTaskSubmitButton />
    </Modal.Footer>
  </>
);
